export function formatLockMode(mode?: number): string {
  switch (mode) {
    case 1:
      return '4-Wheel Bin – Lift & Tip Detection';
    case 2:
      return '2-Wheel Bin – Lift & Tip Detection';
    case 3:
      return '2-Wheel Bin – Lift Detection Only';
    case 4:
      return 'Detection Disabled';
    default:
      return mode != null ? mode.toString() : '-';
  }
}
